import axios from 'axios';

import soundManager from '../utils/SoundManager';
import logger from '../utils/logger';
import logError from '../utils/logError';

export const checkRunningTests = async (testServiceBaseUrl) => {
  try {
    if (!testServiceBaseUrl) {
      throw new Error('Missing test service base URL');
    }
    const csrfToken = localStorage.getItem('csrfToken');

    const response = await axios.get(`${testServiceBaseUrl}/tests/running`, {
      responseType: 'json',
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        'X-CSRF-Token': csrfToken,
      },
    });

    const { noFailedTestNotReported, sounds } = response.data;
    // Older backends do not return processing details, which simply means no recovery work.
    const processing = Array.isArray(response.data.processing) ? response.data.processing : [];

    if (Array.isArray(sounds)) {
      for (const sound of sounds) {
        if (sound) soundManager.play(sound); // sounds are queued in order
      }
    } else if (typeof sounds === 'string') {
      soundManager.play(sounds);
    }

    return {
      isTestNotFailedAndNotReported: noFailedTestNotReported,
      sounds,
      processing,
    };
  } catch (error) {
    logger.error(logError(error, { action: 'checkRunningTests' }));
    return { isTestNotFailedAndNotReported: false, sounds: undefined, processing: [] };
  }
};

// Asks the backend to atomically claim and restart an interrupted processing run.
export const recoverInterruptedTest = async (testServiceBaseUrl, id) => {
  if (!testServiceBaseUrl) {
    throw new Error('Missing test service base URL');
  }
  if (!id) {
    throw new Error('Missing test ID');
  }

  return axios.post(
    `${testServiceBaseUrl}/tests/rerun`,
    { id, interruptedRecovery: true },
    {
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        'X-CSRF-Token': localStorage.getItem('csrfToken'),
      },
    },
  );
};
